module.exports = __webpack_public_path__ + "static/media/know02.4fb9a0a7.jpg";